export default __webpack_public_path__ + "static/media/MaskGroup.100903da.png";